import React, { useState } from 'react';
import { Menu, X, User, LogOut } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const {
    user,
    logout,
    isAuthenticated,
    isVendor,
    isCustomer
  } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    setIsProfileOpen(false);
  };
  // Function to handle profile click
  const handleProfileClick = () => {
    if (isVendor) {
      navigate('/vendor');
      return;
    }
    if (isCustomer) {
      navigate('/customer');
      return;
    }
    // For other user types, just toggle the dropdown
    setIsProfileOpen(!isProfileOpen);
  };
  return <header className="w-full bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-298">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-299">
        <div className="flex justify-between items-center h-16" data-id="element-300">
          <div className="flex items-center" data-id="element-301">
            <div className="flex-shrink-0" data-id="element-302">
              <Link to="/" className="text-xl font-bold text-primary" data-id="element-303">
                Smart Homebox
              </Link>
            </div>
          </div>
          <nav className="hidden md:flex space-x-8" data-id="element-304">
            <a href="#services" className="text-gray-600 hover:text-primary font-medium" data-id="element-305">
              Services
            </a>
            <a href="#how-it-works" className="text-gray-600 hover:text-primary font-medium" data-id="element-306">
              How It Works
            </a>
            <Link to="/become-vendor" className="text-gray-600 hover:text-primary font-medium" data-id="element-307">
              For Vendors
            </Link>
            <Link to="/request-service" className="text-gray-600 hover:text-primary font-medium" data-id="element-308">
              Request Service
            </Link>
          </nav>
          {isAuthenticated ? <div className="hidden md:flex items-center" data-id="element-309">
              <div className="relative" data-id="element-310">
                <button onClick={handleProfileClick} className="flex items-center space-x-2 text-gray-700 hover:text-primary focus:outline-none" data-id="element-311">
                  <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-312">
                    <User className="h-5 w-5 text-primary" data-id="element-313" />
                  </div>
                  <span data-id="element-314">{user?.name}</span>
                </button>
                {isProfileOpen && <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200" data-id="element-315">
                    <div className="px-4 py-2 border-b border-gray-200" data-id="element-316">
                      <p className="text-sm font-medium text-gray-900" data-id="element-317">
                        {user?.name}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-318">{user?.email}</p>
                      <p className="text-xs font-medium text-primary mt-1 capitalize" data-id="element-319">
                        {user?.type}
                      </p>
                    </div>
                    {isVendor && <Link to="/vendor" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-320">
                        Vendor Portal
                      </Link>}
                    {isCustomer && <Link to="/customer" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-321">
                        Customer Portal
                      </Link>}
                    <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-322">
                      Your Profile
                    </a>
                    <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-323">
                      Settings
                    </a>
                    <button onClick={handleLogout} className="flex items-center w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100" data-id="element-324">
                      <LogOut className="h-4 w-4 mr-2" data-id="element-325" />
                      Sign out
                    </button>
                  </div>}
              </div>
            </div> : <div className="hidden md:flex items-center space-x-4" data-id="element-326">
              <Link to="/become-vendor" className="px-4 py-2 rounded-md text-primary border border-primary hover:bg-primary hover:text-white transition-colors" data-id="element-327">
                For Vendors
              </Link>
              <Link to="/auth/customer-login" className="px-4 py-2 rounded-md bg-primary text-white hover:bg-primary/90 transition-colors" data-id="element-328">
                Customer Login
              </Link>
            </div>}
          <div className="md:hidden" data-id="element-329">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-primary hover:bg-gray-100 focus:outline-none" data-id="element-330">
              {isMenuOpen ? <X size={24} data-id="element-331" /> : <Menu size={24} data-id="element-332" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-333">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-334">
            <a href="#services" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50" data-id="element-335">
              Services
            </a>
            <a href="#how-it-works" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50" data-id="element-336">
              How It Works
            </a>
            <Link to="/become-vendor" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50" data-id="element-337">
              For Vendors
            </Link>
            <Link to="/request-service" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50" data-id="element-338">
              Request Service
            </Link>
          </div>
          {isAuthenticated ? <div className="pt-4 pb-3 border-t border-gray-200" data-id="element-339">
              <div className="flex items-center px-5" data-id="element-340">
                <div className="flex-shrink-0 h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-341">
                  <User className="h-6 w-6 text-primary" data-id="element-342" />
                </div>
                <div className="ml-3" data-id="element-343">
                  <div className="text-base font-medium text-gray-800" data-id="element-344">
                    {user?.name}
                  </div>
                  <div className="text-sm font-medium text-gray-500" data-id="element-345">
                    {user?.email}
                  </div>
                </div>
              </div>
              <div className="mt-3 space-y-1 px-5" data-id="element-346">
                {isVendor && <Link to="/vendor" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50" data-id="element-347">
                    Vendor Portal
                  </Link>}
                {isCustomer && <Link to="/customer" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50" data-id="element-348">
                    Customer Portal
                  </Link>}
                <a href="#" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50" data-id="element-349">
                  Your Profile
                </a>
                <a href="#" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50" data-id="element-350">
                  Settings
                </a>
                <button onClick={handleLogout} className="w-full text-left flex items-center px-3 py-2 rounded-md text-base font-medium text-red-600 hover:bg-gray-50" data-id="element-351">
                  <LogOut className="h-5 w-5 mr-2" data-id="element-352" />
                  Sign out
                </button>
              </div>
            </div> : <div className="pt-4 pb-3 border-t border-gray-200" data-id="element-353">
              <div className="flex items-center justify-between px-5 space-x-3" data-id="element-354">
                <Link to="/become-vendor" className="flex-1 px-4 py-2 text-center text-sm font-medium rounded-md text-primary border border-primary hover:bg-primary hover:text-white transition-colors" data-id="element-355">
                  For Vendors
                </Link>
                <Link to="/auth/customer-login" className="flex-1 px-4 py-2 text-center text-sm font-medium rounded-md bg-primary text-white hover:bg-primary/90 transition-colors" data-id="element-356">
                  Customer Login
                </Link>
              </div>
            </div>}
        </div>}
    </header>;
}